<template>
  <GestionAdjuntos/>
</template>
<script setup>
import GestionAdjuntos from "@/views/admin/atencionAdjuntos/components/GestionAtencionAdjuntos.vue";
</script>
